module.exports = __webpack_public_path__ + "static/1-52671b20e335a46c21b886ef6ff91263.jpg";